import { generateSkinDefaults } from '@wix/editor-elements-panel';
import type { SkinDefinition } from '@wix/editor-elements-panel/src/adapters/types';

export const wutBadgeSkinDefinitionMap: Record<string, SkinDefinition> = {
  'wixui.skins.WutBadge': {
    background: {
      type: 'BACKGROUND_FILL',
      defaultValue: 'rgba(var(--color_18),0.1)',
      state: 'regular',
    },
    'box-shadow': {
      type: 'BOX_SHADOW',
      defaultValue: '0 1px 4px rgba(0, 0, 0, .6)',
      state: 'regular',
    },
    font: {
      type: 'FONT',
      defaultValue: 'font_8',
      state: 'regular',
    },
    color: {
      type: 'CSS_COLOR',
      defaultValue: '#ff0000',
      state: 'regular',
    },
    'text-display': {
      type: 'CSSString',
      defaultValue: 'initial',
      state: 'regular',
    },
    'letter-spacing': {
      type: 'SIZE',
      defaultValue: '0em',
      state: 'regular',
    },
    'line-height': {
      type: 'SIZE',
      defaultValue: 'unset',
      state: 'regular',
    },
    'text-decoration': {
      type: 'CSSString',
      defaultValue: 'none',
      state: 'regular',
    },
    // eslint-disable-next-line editor-elements/no-direction-in-skin-params
    direction: {
      type: 'CSSString',
      defaultValue: 'ltr',
      state: 'regular',
    },
    'text-align': {
      type: 'CSSString',
      defaultValue: 'revert',
      state: 'regular',
    },
    'text-highlight': {
      type: 'COLOR_ALPHA',
      defaultValue: 'none',
      state: 'regular',
    },
    'text-transform': {
      type: 'CSSString',
      defaultValue: 'none',
      state: 'regular',
    },
    'text-outline': {
      type: 'CSSString',
      defaultValue:
        '1px 0px transparent, -1px 0px transparent, 0px 1px transparent, 0px -1px transparent',
      state: 'regular',
    },
    'text-shadow': {
      type: 'TEXT_SHADOW',
      defaultValue: '0px 0px transparent',
      state: 'regular',
    },

    'border-left': {
      type: 'BORDER_SIDE',
      defaultValue: '0px none #000000',
      state: 'regular',
    },
    'border-right': {
      type: 'BORDER_SIDE',
      defaultValue: '0px none #000000',
      state: 'regular',
    },
    'border-top': {
      type: 'BORDER_SIDE',
      defaultValue: '0px none #000000',
      state: 'regular',
    },
    'border-bottom': {
      type: 'BORDER_SIDE',
      defaultValue: '0px none #000000',
      state: 'regular',
    },

    'border-top-left-radius': {
      type: 'SIZE',
      defaultValue: '0px',
      state: 'regular',
    },
    'border-top-right-radius': {
      type: 'SIZE',
      defaultValue: '0px',
      state: 'regular',
    },
    'border-bottom-right-radius': {
      type: 'SIZE',
      defaultValue: '0px',
      state: 'regular',
    },
    'border-bottom-left-radius': {
      type: 'SIZE',
      defaultValue: '0px',
      state: 'regular',
    },

    'padding-bottom': {
      type: 'SIZE',
      defaultValue: '2px',
      state: 'regular',
    },
    'padding-top': {
      type: 'SIZE',
      defaultValue: '2px',
      state: 'regular',
    },
    'padding-left': {
      type: 'SIZE',
      defaultValue: '12px',
      state: 'regular',
    },
    'padding-right': {
      type: 'SIZE',
      defaultValue: '12px',
      state: 'regular',
    },

    'icon-display': {
      type: 'CSSString',
      defaultValue: 'initial',
      state: 'regular',
    },
    'icon-size': {
      type: 'SIZE',
      defaultValue: '10px',
      state: 'regular',
    },
    'icon-color': {
      type: 'CSS_COLOR',
      defaultValue: 'rgba(0,0,255,0.5)',
      state: 'regular',
    },
    'icon-rotation': {
      type: 'CSSString',
      defaultValue: '0',
      state: 'regular',
    },
  },
};

export default generateSkinDefaults(wutBadgeSkinDefinitionMap);
